// 应用配置
export const APP_CONFIG = {
  // 后端API地址 - 开发环境使用相对路径通过代理转发到datas域名，生产环境直接使用完整URL
  // eslint-disable-next-line no-undef
  BASE_API: process.env.NODE_ENV === 'development' ? '/' : 'https://datas.8090pay.com', // 开发环境使用/走代理转发，生产环境直接访问 'https://datas.8090pay.com'
  // BASE_API: 'https://sui.nsgames.cn', // 生产环境域名
  // 应用信息
  APP_ID: 14, // 企业服务平台的ID - 修改为1匹配数据库中的现有应用
  APP_KEY: 'FScIguDHUEoPz7Q-yjU58w==',  // 从service_platform_backend获取的应用密钥 - 修改为默认密钥
  
  // 公司信息
  COMPANY_NAME: '宁德市天晓传媒', // 公司名称
  ICP_NUMBER: '闽ICP备2026006013号', // ICP备案号
  ICP_URL: 'https://beian.miit.gov.cn/', // 备案查询网址
  
  // 支付配置
  DEFAULT_PAYMENT_METHOD: 'epay_alipay', // 默认支付方式
  
  // 其他配置
  TIMEOUT: 15000, // 请求超时时间
  
  // 主题配置
  THEME: 'purple', // 可选: 'blue', 'green', 'purple', 'red', 'orange'
  
  // 主题颜色配置
  THEME_COLORS: {
    blue: {
      primary: '#3b82f6',      // blue-500
      primaryHover: '#2563eb', // blue-600
      primaryActive: '#1d4ed8', // blue-700
      primaryLight: '#dbeafe',  // blue-100
      primaryBg: '#eff6ff',     // blue-50
      primaryBorder: '#3b82f6', // blue-500
      primaryText: '#3b82f6',   // blue-600
      gradientFrom: '#60a5fa',  // blue-400
      gradientVia: '#3b82f6',   // blue-500
      gradientTo: '#2563eb',    // blue-600
    },
    green: {
      primary: '#10b981',       // green-500
      primaryHover: '#059669',   // green-600
      primaryActive: '#047857', // green-700
      primaryLight: '#d1fae5',  // green-100
      primaryBg: '#ecfdf5',     // green-50
      primaryBorder: '#10b981', // green-500
      primaryText: '#059669',   // green-600
      gradientFrom: '#34d399',  // green-400
      gradientVia: '#10b981',   // green-500
      gradientTo: '#059669',    // green-600
    },
    purple: {
      primary: '#8b5cf6',       // purple-500
      primaryHover: '#7c3aed', // purple-600
      primaryActive: '#6d28d9', // purple-700
      primaryLight: '#e9d5ff',  // purple-100
      primaryBg: '#f5f3ff',     // purple-50
      primaryBorder: '#8b5cf6', // purple-500
      primaryText: '#7c3aed',   // purple-600
      gradientFrom: '#a78bfa',  // purple-400
      gradientVia: '#8b5cf6',   // purple-500
      gradientTo: '#7c3aed',    // purple-600
    },
    red: {
      primary: '#ef4444',       // red-500
      primaryHover: '#dc2626',  // red-600
      primaryActive: '#b91c1c', // red-700
      primaryLight: '#fee2e2',  // red-100
      primaryBg: '#fef2f2',     // red-50
      primaryBorder: '#ef4444', // red-500
      primaryText: '#dc2626',   // red-600
      gradientFrom: '#f87171',  // red-400
      gradientVia: '#ef4444',   // red-500
      gradientTo: '#dc2626',    // red-600
    },
    orange: {
      primary: '#f97316',       // orange-500
      primaryHover: '#ea580c',  // orange-600
      primaryActive: '#c2410c', // orange-700
      primaryLight: '#ffedd5',  // orange-100
      primaryBg: '#fff7ed',     // orange-50
      primaryBorder: '#f97316', // orange-500
      primaryText: '#ea580c',   // orange-600
      gradientFrom: '#fb923c',  // orange-400
      gradientVia: '#f97316',   // orange-500
      gradientTo: '#ea580c',    // orange-600
    }
  }
}
